import { TutorialDialog } from "@nova/component-tutorial-dialog"
import * as Typography from "@nova/component-typography"
import * as Icons from "@nova/component-icons"
import { Trans } from "react-i18next"
import { createElement } from "react"

export const IconTutorial = () => {
    return (
        <TutorialDialog>
            <Typography.TutorialText className="text-black">
                <Icons.IconBox className="mb-[10px] text-[16px] !flex justify-center items-center">
                    <Icons.IconTool className="!m-0 text-[16px] scale-[80%]" stroke="#384E9D" />
                </Icons.IconBox>
                <Trans
                    i18nKey="tutorial:create-icon"
                    components={{
                        h: <Typography.TutorialHeader />,
                        ...Typography.CommonTranslationTags,
                        strong: <Typography.Strong className="text-[#384E9D]" />,
                        p: createElement(({ children }: { children: React.ReactNode }) => (
                            <span style={{ fontSize: "10pt" }}>{children}</span>
                        )),
                    }}
                />
            </Typography.TutorialText>
        </TutorialDialog>
    )
}
